import React, { MouseEventHandler, useEffect, useState } from "react";
import "antd/dist/antd.css";
import { Row, Col, Input } from "antd";
import styles from "./DashBoard.module.scss";
import textStyles from "../../components/DashBoard/BookingSummary/BookingSummary.module.scss";
import serviceStyles from "../Header/Header.module.scss";
import {
  addUsers,
  rightOutlined,
  allUserIcon,
  searchOutlinedIcon,
} from "../../assets/images";
import EllipsisText from "../../helpers/EllipsisText/EllipsisText";
import { WandaUserInfo } from "../../types/PersonTypes";
import { useDashboardCtx } from "../../context/DashboardContext";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useTripsCtx } from "../../context/TripDetailsContext";

type Props = {
  serviceData: WandaUserInfo[];
  handleAddServiceUser: MouseEventHandler<HTMLDivElement>;
  showMobileDashboardView: boolean;
};

interface Person {
  firstName: string;
  lastName: string;
}

function PersonSearch({
  serviceData,
  handleAddServiceUser,
  showMobileDashboardView,
}: Props) {
  const { Search } = Input;
  const { selectedPersonIdCtx, showTabsCtx } = useDashboardCtx();
  const {isServiceUsersLoading} = useTripsCtx();
  const [selectedPersonId, setSelectedPersonId] = selectedPersonIdCtx;
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [nameFilteredData, setNameFilteredData] = useState<WandaUserInfo[]>(
    serviceData
  );
  const [selectServiceUser, setSelectServiceUser] = useState<number>(0);
  const searchData = isSearch ? nameFilteredData : serviceData;
  const [showTabs, setShowTabs] = showTabsCtx;
  const { width } = useWindowSize();
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (!value.trim()) {
      setIsSearch(false);
      setSelectedPersonId("");
      setSelectServiceUser(0);
    }
  };

  const onSearch = (value: string) => {
    setIsSearch(true);

    const filtered = serviceData.filter(
      (item: { firstName: string; lastName: string }) => {
        const searchLowerCase = value.toLowerCase();
        const firstNameLowerCase = item.firstName.toLowerCase();
        const lastNameLowerCase = item.lastName.toLowerCase();
        return (
          firstNameLowerCase.includes(searchLowerCase) ||
          lastNameLowerCase.includes(searchLowerCase)
        );
      }
    );

    setNameFilteredData(filtered);
  };
  const handleShowAllUser = () => {
    setShowTabs(true);
    setSelectedPersonId("");
    setSelectServiceUser(0);
  };

  const handleSingleServiceUsersClick = (personId: number) => {
    const val = String(personId);
    setSelectedPersonId(val);
    setSelectServiceUser(personId);
    setShowTabs(true);
  };
  useEffect(() => {
    if (selectedPersonId) {
      setSelectServiceUser(Number(selectedPersonId));
    }
  }, [selectedPersonId]);

  return (
    <>
      <Col
        xs={!showMobileDashboardView ? 24 : 0}
        lg={9}
        className={styles.serviceUserContainer}
      >
        <Col
          className={`${styles.serviceUserHeading} ${textStyles.normalText20}`}
        >
          <Row className={styles.serviceUserHeadingContainer}>
            <Col span={18}>Service Users </Col>
            {!isServiceUsersLoading && serviceData.length < 25 && (
              <>
                <Col span={6} className={styles.contentRight}>
                  <img
                    className={styles.addUSerImg}
                    onClick={handleAddServiceUser}
                    src={addUsers}
                    alt="add user"
                  />
                </Col>
              </>
            )}
            {serviceData.length > 1 && (
              <Row className={styles.nameSearchInputContainer}>
                {" "}
                <Search
                  className={styles.nameSearchInput}
                  allowClear
                  placeholder="Search name"
                  onSearch={onSearch}
                  onChange={handleSearch}
                />
              </Row>
            )}
          </Row>
        </Col>

        {isSearch && nameFilteredData.length === 0 ? (
          <>
            <Col className={styles.noSericeUserContainer}>
              <Row>
                <img src={searchOutlinedIcon} alt="searchOutlined-Icon" />
              </Row>
              <Row className={styles.noSearchHeading}>
                <Col>No search results</Col>
              </Row>
              <Row className={styles.noSearchWord}>
                <Col>Check your spelling or add a new service user.</Col>
              </Row>
            </Col>
          </>
        ) : (
          <>
            {serviceData.length > 1 && (
              <Col
                className={`${
                  selectedPersonId === "" && selectServiceUser === 0
                    ? styles.isServiceUserSelectedStyle
                    : null
                } ${styles.userList}`}
              >
                <Row
                  justify="space-between"
                  align="middle"
                  className={styles.serviceUsersRow}
                  onClick={handleShowAllUser}
                >
                  <Col span={3}>
                    <img
                      alt="Default-Image"
                      src={allUserIcon}
                      className={serviceStyles.serviceUsersImage}
                    />
                  </Col>
                  <Col
                    span={18}
                    className={`${styles.serviceUsersNames} ${textStyles.normalText16}`}
                  >
                    All {width <= 992 ? "Services" : ""}
                  </Col>
                  <Col span={3}>
                    <img
                      className={styles.rightArrowIcon}
                      alt="Right-Arrow"
                      src={rightOutlined}
                    />
                  </Col>
                </Row>
              </Col>
            )}

            <div
              className={`${
                searchData.length > 9 ? styles.scrollContainer : null
              }`}
            >
              {searchData.map((user: WandaUserInfo) => (
                <Col
                  key={user.personId}
                  className={`${
                    selectServiceUser === user.personId ||
                    searchData.length === 1
                      ? styles.isServiceUserSelectedStyle
                      : ""
                  } ${styles.userList}`}
                >
                  <Row
                    justify="space-between"
                    align="middle"
                    className={styles.serviceUsersRow}
                    onClick={() => handleSingleServiceUsersClick(user.personId)}
                  >
                    <Col span={3}>
                      {user.profileImageUrl ? (
                        <img
                          alt="User-Image"
                          src={user.profileImageUrl}
                          className={serviceStyles.serviceUsersImage}
                        />
                      ) : (
                        <img
                          alt="Default-Image"
                          src={allUserIcon}
                          className={serviceStyles.serviceUsersImage}
                        />
                      )}
                    </Col>
                    <Col
                      span={18}
                      className={`${styles.serviceUsersNames} ${textStyles.normalText16}`}
                    >
                      <EllipsisText
                        text={`${user.firstName} ${user.lastName}`}
                        maxVisibleTextLength={20}
                      />
                    </Col>
                    <Col span={3}>
                      <img
                        className={styles.rightArrowIcon}
                        alt="Right-Arrow"
                        src={rightOutlined}
                      />
                    </Col>
                  </Row>
                </Col>
              ))}
            </div>
          </>
        )}
      </Col>
    </>
  );
}

export default PersonSearch;
